import {TranslationObject} from '@colonist/i18n'
import {PIXI} from '@colonist/pixi'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {GameFont} from '../../GameFont'
import {UIGameManager} from '../UIGameManager'
import {MovingSectionView} from '../../ui_canvas_engine/MovingSectionView'
import {TextTruncatedView} from '../../ui_canvas_engine/TextTruncatedView'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameGoToPointFadeAnimation} from '../../ui_canvas_engine/animation/UIGameGoToPointFadeAnimation'
import {UIGameAnimationBase} from '../../ui_canvas_engine/animation/UIGameAnimationBase'
import {GameColor} from '../../GameColor'

export class UIGameFloatingVictoryPointsView extends MovingSectionView {
    protected readonly uiGameManager: UIGameManager

    private ribbonView: SpriteView
    private textView: TextTruncatedView
    private trophyView: SpriteView

    constructor(uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, container: PIXI.Container, text: TranslationObject, texture: PIXI.Texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.ribbon_large)) {
        super(x, y, w, h, container)
        this.uiGameManager = uiGameManager
        this.drawFloatingVPView(texture, text)

        this.zIndex = this.uiGameManager.mapController.mapView.layers.mapCityWall
        this.eventMode = 'none'
    }

    protected drawFloatingVPView(texture: PIXI.Texture, text: TranslationObject) {
        this.drawBackground(texture)
        this.drawText(text, GameFont.Size.Normal)
        this.drawTrophy()
    }

    protected drawBackground(texture: PIXI.Texture) {
        this.ribbonView?.destroy()
        this.ribbonView = new SpriteView(0, 0, this.width, this.height, this, texture)
        this.ribbonView.centerXInParent()
    }

    protected drawText(text: TranslationObject, fontSize: GameFont.Size) {
        const textW = this.width * 0.6
        this.textView?.destroy()
        this.textView = new TextTruncatedView(text, 0, 0, textW, this.height, this)
        this.textView.changeStyle({fontWeight: GameFont.Weight.Bold, fontSize: GameFont.getResponsiveSize(fontSize), fill: GameColor.Color.Gray0}, false)
        this.textView.centerXInParent()
        this.textView.centerYInParent()
    }

    protected drawTrophy() {
        this.trophyView?.destroy()
        const trophyViewH = this.height * 0.7
        const trophyTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy)
        const trophyViewW = (trophyViewH * trophyTexture.width) / trophyTexture.height
        this.textView.x = (this.width - this.textView.width - this.uiGameManager.canvasController.margin / 2 - trophyViewW) / 2
        const trophyViewX = this.textView.x + this.textView.width + this.uiGameManager.canvasController.margin / 2
        const trophyViewY = this.height / 2 - trophyViewH / 2 - this.uiGameManager.canvasController.margin / 3

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trophy)
        this.trophyView = new SpriteView(trophyViewX, trophyViewY, trophyViewW, trophyViewH, this, texture)
        this.trophyView.cacheAsBitmap = true
    }

    setVerticalAnimation(distanceY: number, velocityY: number, fadeSpeed: number, howToWinAnimation: boolean = false, delayBetweenAnimations: number = 2000) {
        const firstStopPoint = new PIXI.Point(this.x, this.y - distanceY)
        const secondStopPoint = new PIXI.Point(this.x, this.y - distanceY * 2)

        const firstStepAnimation = new UIGameGoToPointFadeAnimation(this, firstStopPoint, velocityY, {initialAlpha: 0, fadeSpeed: fadeSpeed, completionPercentageToStartFade: 0, isFadeIn: true})
        const secondStepAnimation = new UIGameGoToPointFadeAnimation(this, secondStopPoint, velocityY, {initialAlpha: 1, fadeSpeed: fadeSpeed, completionPercentageToStartFade: 0, isFadeIn: false})
        secondStepAnimation.setOnStopCallback(() => this.parent.removeChild(this))

        UIGameAnimationBase.composeAnimations([firstStepAnimation, secondStepAnimation], delayBetweenAnimations).start()
    }
}
